import React from 'react';
import { Helmet } from 'react-helmet-async';

const About = () => {
  return (
    <div className="about-page fade-in">
      <Helmet>
        <title>عن الموقع وسياسة الخصوصية | بكام الذهب</title>
        <meta name="description" content="تعرف على فريق عمل موقع بكام الذهب، سياستنا التحريرية، وكيفية التواصل معنا." />
      </Helmet>

      <div className="container" style={{ padding: '40px 20px', maxWidth: '800px' }}>
        <section style={{ marginBottom: '40px' }}>
          <h1 style={{ fontSize: '2rem', color: 'var(--color-gold-dark)', marginBottom: '20px' }}>عن موقع بكام الذهب</h1>
          <p style={{ lineHeight: '1.8', color: 'var(--color-text-secondary)' }}>
            موقع <strong>بكام الذهب</strong> هو منصة متخصصة تهدف إلى توفير أدق وأحدث أسعار الذهب في الأسواق العربية (مصر، السعودية، الإمارات، الكويت، قطر) لحظة بلحظة. نحن نؤمن بأن الوصول إلى المعلومة الصحيحة هو حق لكل مستثمر ومستهلك.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '15px' }}>سياستنا التحريرية (Editorial Policy)</h2>
          <p style={{ lineHeight: '1.8', color: 'var(--color-text-secondary)' }}>
            نحن نعتمد في جلب بياناتنا على مصادر رسمية وعالمية موثوقة، ونقوم بتحديث الأسعار ثلاث مرات يومياً لضمان الدقة. جميع المقالات والتحليلات المنشورة تخضع لمراجعة دقيقة لضمان تقديم محتوى عالي الجودة ومفيد للقارئ.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '15px' }}>سياسة الخصوصية (Privacy Policy)</h2>
          <p style={{ lineHeight: '1.8', color: 'var(--color-text-secondary)' }}>
            نحن نحترم خصوصيتك تماماً. لا يقوم الموقع بجمع أي بيانات شخصية عن الزوار إلا ما تطلبه أدوات تحليل جوجل (Google Analytics) لتحسين تجربة المستخدم، ونحن نلتزم بعدم مشاركة أي معلومات مع أي جهة خارجية.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '15px' }}>تواصل معنا</h2>
          <p style={{ lineHeight: '1.8', color: 'var(--color-text-secondary)' }}>
            إذا كان لديك أي استفسار أو اقتراح، يمكنك التواصل معنا عبر البريد الإلكتروني:
            <br />
            <a href="mailto:contact@bekamdahab.com" style={{ color: 'var(--color-gold-dark)', fontWeight: '700' }}>contact@bekamdahab.com</a>
          </p>
        </section>

      </div>
    </div>
  );
};

export default About;
